import icons from "../../assets/icons";
import "../../styles/widgets/widgets.css";
import { ProgressIcon } from "./loading";


/**
 * @typedef { "download" | "add" | "cancel" | "confirm" | "undo" } ButtonIcon
 * @typedef { "red" | "green" } ButtonColor
 * @param {{ icon: ButtonIcon, disabled: boolean, inProgress: boolean, color: ButtonColor, onClick: Function }} param0 
 */
export function Button({ icon, className, inProgress = false, disabled = false, color = "", onClick = (() => {}), children }) {
    
    const buttonClasses = [ className || "", icon && !inProgress ? `btn-${icon}` : "btn" ];
    if(color) buttonClasses.push(color);
    if(disabled || inProgress) buttonClasses.push("disabled");

    return (<button className={buttonClasses.join(" ")} onClick={onClick} >
        { inProgress ? <ProgressIcon /> : [] }
        {children}
    </button>)
}

export function IconButton({ icon, onClick, size }) {
    const style = {
        backgroundImage: `url(${icons[icon]})`
    };

    if(size) {
        style.height = size + "px";
        style.width = size + "px";
    }
    
    return <button className="icon-btn" style={style} onClick={onClick} />
}